
export const DAYS_OF_WEEK_LABEL = {
	monday: 'Mon',
	tuesday: 'Tue',
	wednesday: 'Web',
	thursday: 'Thu',
	friday: 'Fri',
	saturday: 'Sat',
	sunday: 'Sun',
};
